import { render, staticRenderFns } from "./mobile-doc-page.vue?vue&type=template&id=71208ddb"
import script from "./mobile-doc-page.vue?vue&type=script&lang=js"
export * from "./mobile-doc-page.vue?vue&type=script&lang=js"
import style0 from "./mobile-doc-page.vue?vue&type=style&index=0&id=71208ddb&prod&lang=less&scope=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports